/**
 * Custom inline SVG icons for the side nav rail.
 */
import { useId } from 'react';

export const IconAnalyticsBars = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M9.25 20.25V13.75H3.75V20.25H9.25ZM9.25 20.25H14.75M9.25 20.25V3.75H14.75V20.25M14.75 20.25H20.25V8.75H14.75V20.25Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconApplicationsGrid = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M0.75 0.75H8.43182V8.43182H0.75V0.75Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5682 0.75H20.25V8.43182H12.5682V0.75Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.75 12.5682H8.43182V20.25H0.75V12.5682Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5682 16.4091C12.5682 14.2878 14.2878 12.5682 16.4091 12.5682C18.5304 12.5682 20.25 14.2878 20.25 16.4091C20.25 18.5304 18.5304 20.25 16.4091 20.25C14.2878 20.25 12.5682 18.5304 12.5682 16.4091Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconDiscoveryCompass = () => {
  const needleHoleId = useId();
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <mask id={needleHoleId}>
        <rect width="22" height="22" fill="black" />
        <path
          d="M15.25 5.75L8.60433 8.60409L6.271 15.7708L12.9377 12.9374L15.25 5.75Z"
          fill="white"
          stroke="white"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <circle cx="10.771" cy="10.7708" r="2" fill="black" />
      </mask>
      <path
        d="M20.7917 10.7708C20.7917 16.3052 16.3052 20.7917 10.7708 20.7917C5.23648 20.7917 0.75 16.3052 0.75 10.7708C0.75 5.23648 5.23648 0.75 10.7708 0.75C16.3052 0.75 20.7917 5.23648 20.7917 10.7708Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <rect
        width="22"
        height="22"
        fill="white"
        mask={`url(#${needleHoleId})`}
      />
    </svg>
  );
};

export const IconReportsStack = () => {
  const backCardId = useId();
  const frontCardId = useId();
  return (
    <svg
      width="24"
      height="21"
      viewBox="0 0 24 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <mask id={backCardId}>
        <rect
          x="3.13037"
          y="3.5"
          width="20.8696"
          height="17.5"
          rx="1"
          fill="white"
        />
        <rect width="20.8696" height="17.5" rx="1" fill="black" />
      </mask>
      <rect
        x="3.13037"
        y="3.5"
        width="20.8696"
        height="17.5"
        rx="1"
        fill="none"
        stroke="white"
        strokeWidth="3"
        mask={`url(#${backCardId})`}
      />
      <mask id={frontCardId} fill="white">
        <rect width="20.8696" height="17.5" rx="1" />
      </mask>
      <rect
        width="20.8696"
        height="17.5"
        rx="1"
        fill="none"
        stroke="white"
        strokeWidth="3"
        mask={`url(#${frontCardId})`}
      />
      <path
        d="M4.5 13.5L8.5 10L11 13L16.5 7.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="4.75"
        y1="4.25"
        x2="10.25"
        y2="4.25"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
